/* eslint camelcase: 0 */
export { default as de_DE } from './de_de.json';
export { default as en_US } from './en_us.json';
export { default as es_ES } from './es_es.json';
export { default as fr_FR } from './fr_fr.json';
export { default as it_IT } from './it_it.json';
export { default as ja_JP } from './ja_jp.json';
export { default as ko_KR } from './ko_kr.json';
export { default as pt_BR } from './pt_br.json';
export { default as zh_CN } from './zh_cn.json';
export { default as zh_TW } from './zh_tw.json';



// WEBPACK FOOTER //
// ./src/components/TermsOfUseDialog/__localization__/TermsOfUseDialog/index.js